import React, { useState, useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { VIEW_BOOKING } from "../../../../services/ApiCalls";
import { catchAsync, checkResponse } from "../../../../utilities/utilities";
import Loader from "../../../../components/Common/Loader";
import moment from "moment";

const OrderDetail = () => {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [bookingDetails, setBookingDetails] = useState(null);
  const [paymentDetail, setPaymentDetail] = useState(null);

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await VIEW_BOOKING(id);
    // console.log(res?.data,"response data")
    if (res.status === 200 && res.data) {
      setBookingDetails(res.data.data?.bookingDetail);
      setPaymentDetail(res.data.data?.paymentDetail);
    }
    setLoader(false);
  }, setLoader);

  useEffect(() => {
    if (id) getData();
  }, [id]);

  if (loader) return <Loader />;
  // console.log(bookingDetails,"bookingDetails===")
  // console.log(paymentDetail,"paymentDetail====")

  return (
    <section className="detail position-relative py-3">
      <Container>
        <Row>
          <Col lg="12">
            <div className="d-flex align-items-center gap-10">
              <Button
                onClick={() => navigate(-1)}
                className="border d-flex align-items-center p-2 rounded"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 10 16"
                  fill="none"
                >
                  <path
                    d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                    fill="#fff"
                    stroke="#1E232C"
                    strokeWidth="0.2"
                  />
                </svg>
              </Button>
              <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                Booking Details
              </h4>
            </div>
          </Col>

          <Col lg="6" className="my-2">
            <label
              style={{ fontSize: "1.3rem", fontWeight: "bold" }}
              className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
            >
              User Detail
            </label>
            <div
              className="cardCstm px-lg-4 px-3 py-2 rounded"
              style={{ background: "#eee" }}
            >
              <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">Name:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {bookingDetails
                      ? bookingDetails.customerId.first_name +
                        " " +
                        bookingDetails.customerId.last_name
                      : ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">Email:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {/* Email missing in customerId, you can show empty or add from paymentDetail if available */}
                    -
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">Phone:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {bookingDetails?.customerId.mobileNumber || ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">Country:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {bookingDetails?.customerId.country || ""}
                  </p>
                </li>
              </ul>
            </div>
          </Col>

          <Col lg="6" className="my-2">
            <label
              style={{ fontSize: "1.3rem", fontWeight: "bold" }}
              className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
            >
              Hotel Details
            </label>
            <div
              className="cardCstm px-lg-4 px-3 py-2 rounded"
              style={{ background: "#eee" }}
            >
              <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">Hotel Name:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {bookingDetails?.hotelId.hotelName || ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">Hotel Id:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {bookingDetails?.hotelId.hotelId || ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">Email:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {bookingDetails?.hotelId.email || ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">Phone:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {bookingDetails?.hotelId.mobileNumber || ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">Address:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {bookingDetails?.hotelId.address || ""}
                  </p>
                </li>
              </ul>
            </div>
          </Col>


          <Col lg="6" className="my-2">
            <label
              style={{ fontSize: "1.3rem", fontWeight: "bold" }}
              className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
            >
              Booking Details
            </label>
            <div
              className="cardCstm px-lg-4 px-3 py-2 rounded"
              style={{ background: "#eee" }}
            >
              <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">Booking ID:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {bookingDetails?.bookingId || ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">Cost:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {bookingDetails?.currencySymbol}{" "}
                    {bookingDetails?.finalPrice || ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">Stay Nights:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {bookingDetails?.nightCount || ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">Number Of Guest:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {bookingDetails?.numberOfGuests || ""}
                  </p>
                </li>

                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25"> Booking Status:</p>
                  <p className="m-0 fw-sbold text-muted w-75 text-capitalize">
                    {bookingDetails?.bookingStatus || ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">CheckIn Date:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {bookingDetails
                      ? moment(bookingDetails.startDate).format(
                          "MM-DD-YYYY , HH:mm"
                        )
                      : ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-25">CheckOut Date:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {bookingDetails
                      ? moment(bookingDetails.endDate).format(
                          "MM-DD-YYYY , HH:mm"
                        )
                      : ""}
                  </p>
                </li>
              </ul>
            </div>
          </Col>

          <Col lg="6" className="my-2">
            <label
              style={{ fontSize: "1.3rem", fontWeight: "bold" }}
              className="form-label m-0 pb-2 ps-2 fw-sbold text-muted"
            >
              Payment Details
            </label>
            <div
              className="cardCstm px-lg-4 px-3 py-2 rounded"
              style={{ background: "#eee" }}
            >
              <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-50">Payment Status:</p>
                  <p className="m-0 fw-sbold text-muted w-75 text-capitalize">
                    {paymentDetail?.status || ""}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-50">Service Fee:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {/* Not present in response, maybe 0 or - */}-
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-50">Tax:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {bookingDetails?.taxes ? `$${bookingDetails.taxes}` : "-"}
                  </p>
                </li>
                <li className="py-2 d-flex align-items-start">
                  <p className="m-0 fw-sbold w-50">Total Amount:</p>
                  <p className="m-0 fw-sbold text-muted w-75">
                    {bookingDetails?.currencySymbol}{" "}
                    {bookingDetails?.finalPrice || ""}
                  </p>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default OrderDetail;
